export const default_additional_income = {
  income_type: "",
  description: "",
  yearly_amount: 0
};